import { useRef, useState, useEffect } from "react";
import { BsChevronLeft, BsChevronRight } from "../../../assets/icons/vander";

export const QuickActions = ({ actions = [] }) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScrollButtons = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 200;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    checkScrollButtons();
    const handleResize = () => checkScrollButtons();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [actions]);

  return (
    <div className="quick-actions">
      {canScrollLeft && (
        <button
          className="scroll-btn scroll-btn-left"
          onClick={() => scroll("left")}
        >
          <BsChevronLeft />
        </button>
      )}

      <div
        ref={scrollRef}
        className="actions-container"
        onScroll={checkScrollButtons}
      >
        {actions.map((action, index) => (
          <span
            key={index}
            className="badge rounded-pill text-bg-light fw-semibold action-badge"
            onClick={action.onClick}
          >
            {action.text}
          </span>
        ))}
      </div>

      {canScrollRight && (
        <button
          className="scroll-btn scroll-btn-right"
          onClick={() => scroll("right")}
        >
          <BsChevronRight />
        </button>
      )}
    </div>
  );
};
